var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-video-embed-block" }, [
    _vm.embedUrl
      ? _c("div", { staticClass: "cms-video-embed-block__wrapper" }, [
          _c("iframe", {
            staticClass: "cms-video-embed-block__iframe",
            attrs: {
              src: _vm.embedUrl,
              frameborder: "0",
              allow:
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: "",
            },
          }),
        ])
      : _c("div", { staticClass: "cms-video-embed-block__placeholder" }, [
          _c("i", { staticClass: "fa fa-play-circle" }),
          _vm._v(" "),
          _c("span", [_vm._v("No video URL set")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }